import TelefoneUtilAPI from '@/api/telefoneutil'

export default {
  clear({ commit }) {
    commit('SET_TELEFONES_UTEIS', [])
  },
  fetchAll({ commit }) {
    return new Promise((resolve, reject) => {
      TelefoneUtilAPI.list()
        .then(response => {
          commit('ADD_TELEFONES_UTEIS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
